module.exports = __webpack_public_path__ + "img/brasao-consultor.3f553abd.png";